import React, {Fragment} from 'react';

import {MainFooter} from 'presentation/components';
import {StyledFooterContainer, StyledStack} from './styles';
import {RefundCardList} from '../RefundCardList';
import {PreviewRefundCardList} from '../PreviewRefundCardList';
import {ListStepProps} from './types';

export function ListStep({variant}: ListStepProps) {
	const isPreview = variant === 'preview';

	return (
		<Fragment>
			<StyledStack>{isPreview ? <PreviewRefundCardList /> : <RefundCardList />}</StyledStack>
			<StyledFooterContainer>
				<MainFooter />
			</StyledFooterContainer>
		</Fragment>
	);
}
